import { useEffect, useState } from "react";
import { Checkbox, Grid } from "@mui/material";

const CreditAuth = ({ page, setPage, formData, setFormData }) => {
    const [checked, setChecked] = useState(formData.optIn === "yes" ? true : false);
    const [submitted, setSubmitted] = useState(false);

    const handleOptInChange = () => {
        setChecked(!checked);
        if (checked === true) {
            setFormData({ ...formData, optIn: "no" });
        } else {
            setFormData({ ...formData, optIn: "yes" });
        }
    }
    useEffect(() => {
        setChecked(checked);
    }, [checked]);

    const submitData = () => {
        setSubmitted(true);
        window.dataLayer.push({ 'event': 'loan_submit', 'loanEvent': 'submit', 'loanEventID': 13 });
        // quebec only
        // window.dataLayer.push({'event': 'loan_submitq', 'loanEvent': 'submitq', 'loanEventID': '13q'});

        // console.log(formData);
        // HTTP REQUEST to Loans Canada via Insurdinary server
        fetch(process.env.REACT_APP_INSURDINARY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_LIVE_AUTH_TOKEN
            },
            body: JSON.stringify({
                "test": "no",
                "campaignId": 640,
                "leadSource": "insurdinary.ca",
                "optIn": formData.optIn,
                "ipAddress": formData.ipAddress || "",
                "productName": "personal_loan",
                "productPurpose": formData.productPurpose,
                "requestedAmount": formData.requestedAmount,
                "firstName": formData.firstName,
                "lastName": formData.lastName,
                "email": formData.email,
                "dob": formData.dob,
                "city": formData.city,
                "state": formData.state,
                "country": "CA",
                "postalCode": formData.postalCode,
                "cellPhone": formData.cellPhone,
                "workPhone": formData.workPhone,
                "address": formData.address,
                "ownHome": formData.ownHome,
                "addressLength_months": formData.addressLengthMonths,
                "rentMortgagePayment": formData.rentMortgagePayment,
                "propertyValue": formData.propertyValue,
                "propertyMortgage": formData.propertyMortgage,
                "incomeType": formData.incomeType,
                "employer": formData.employer,
                "jobTitle": formData.jobTitle,
                "monthlyIncome": formData.monthlyIncome,
                "employedMonths": formData.employedMonths,
                "directDeposit": formData.directDeposit,
                "payFrequency": formData.payFrequency,
                "payDate1": formData.payDate1,
                "payDate2": formData.payDate2,
                "creditScore": formData.creditScore,
                "creditAuth": 1,
                "inDmp": formData.inDebtProgram,
                "inBankruptcy": formData.inBankruptcy,
                "inConsumerProposal": formData.inConsumerProposal,
                "ccDeptAmount": formData.ccDebtAmount,
                "unsecuredDeptAmount": formData.unsecuredDebtAmount,
                "canadianStatus": formData.canadianStatus,
                "lang": formData.lang
            })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the response JSON
            })
            .then((data) => {
                if (data.data.redirect_url === null || data.data.redirect_url === undefined || data.success === false) {
                    window.location.replace("https://www.insurdinary.ca/thank-you-loan");
                } else {
                    window.location.replace(data.data.redirect_url);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <div className="card">
            <div className="card-div">
                <div style={{ fontSize: 12, margin: 10 }}>
                    {formData.lang === "fr" ?
                        <div><p><i>Lors de la soumission, afin de maximiser vos chances de trouver un fournisseur de services, vous autorisez le fournisseur de services financiers de confiance avec lequel vous avez été assorti à obtenir des rapports de crédit auprès des agences d'évaluation du crédit afin d'évaluer votre historique de crédit. (Cela n'affecte pas votre cote de crédit.) Votre consentement est valide jusqu'à ce que vous informiez le fournisseur correspondant de votre retrait.</i></p>
                            <p><i>Vous avez le droit de rectifier, de recevoir des copies et de demander la destruction de vos informations personnelles collectées par Insurdinary. Envoyez-nous un courriel à info@insurdinary.com pour ce faire.</i></p></div> :
                        <div><p><i>Upon submission, in order to maximize your chance of finding a service provider, you authorize the trusted financial services provider you have been matched with to obtain credit reports from credit reporting agencies to assess your credit history. (This does not affect your credit score.) Your consent is valid until you notify the matched provider of your withdrawal.</i></p>
                            <p><i>You have the right to rectify, receive copies, and request destruction of your personal information collected by Insurdinary. Email us at info@insurdinary.com to do so.</i></p></div>}
                </div>

                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <Checkbox
                                        checked={checked}
                                        onChange={handleOptInChange}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </td>
                                <td>
                                    {formData.lang === "fr" ? "Je souhaite m'inscrire à la liste email d'Insurdinary pour recevoir des newsletters et offres financiers. (Vous pouvez vous désinscrire à tout moment)" : "I wish to opt-in to the Insurdinary mailing list for newsletters and offers. (You can opt-out at any time)"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        {submitted ?
                            <button className="submit-clicked-button">
                                {formData.lang === "fr" ? "Chargement..." : "Loading..."}
                            </button> :
                            <button className="nav-button"
                                onClick={() => {
                                    submitData();
                                }}>
                                {formData.lang === "fr" ? "Soumettre" : "Submit"}
                            </button>
                        }
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default CreditAuth;